import React from 'react';
import LinkCell from '@/components/table/LinkCell';

const VocabularyUrlCell = ({ vocabulary }) => (
  <LinkCell className="td-description" title={vocabulary.value} value={vocabulary.value} />
);

export default VocabularyUrlCell;
